<ng-container *transloco="let t; prefix: 'dod-directory-list-no-results'">
  <img src="assets/images/collections.svg" alt="" />

  <div class="message">
    {{ t('message') }}
  </div>

  <button
    data-cy="btn-clear-filters"
    class="clear-filters"
    accredible-button-flat
    icon="close"
    iconSize="10px"
    (click)="clearFilters()">
    {{ t('clear_search_filters') }}
  </button>
</ng-container>
